import React from 'react';
export function CredibilitySection() {
  return <section className="py-16 md:py-20 px-4 bg-[#141414]" data-id="element-23">
      <div className="max-w-6xl mx-auto" data-id="element-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-25">
          {/* Left: Image */}
          <div className="flex justify-center" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/cNRjwRH6NSdC7KsbxfS47X/Imagen_Mujer_y_hombre_en_un_cafe.png" alt="Mujer y hombre en un café leyendo el libro" className="w-full max-w-md rounded-lg shadow-2xl object-cover" data-id="element-27" />
          </div>

          {/* Right: Text Content */}
          <div data-id="element-28">
            <div className="flex items-center gap-4 mb-8" data-id="element-29">
              <div className="h-px bg-[#2a2a2a] flex-1" data-id="element-30"></div>
              <h2 className="text-3xl font-serif text-[#C9A84C]" data-id="element-31">
                La glicación: lo que el azúcar hace en silencio dentro de tu
                cuerpo.
              </h2>
              <div className="h-px bg-[#2a2a2a] flex-1" data-id="element-32"></div>
            </div>

            <div className="space-y-4 text-lg md:text-xl text-[#9a9a9a] leading-relaxed font-light mb-10" data-id="element-33">
              <p data-id="element-34">
                La glicación es una reacción natural entre el azúcar y las
                proteínas de tu cuerpo.
              </p>
              <p data-id="element-35">No duele. No avisa. No genera señales inmediatas.</p>
              <p data-id="element-36">
                Pero cuando ocurre de forma constante, deja un rastro silencioso
                que la ciencia lleva décadas estudiando.
              </p>
            </div>

            <div className="border-l-2 border-[#C9A84C] pl-6 space-y-4 text-lg md:text-xl text-white leading-relaxed mb-10" data-id="element-37">
              <p data-id="element-38">Este libro no busca alarmarte.</p>
              <p data-id="element-39">Busca darte claridad.</p>
              <p data-id="element-40">
                Porque cuando entiendes lo que ocurre dentro de ti, comienzas a
                tomar decisiones diferentes.
              </p>
            </div>

            <p className="text-sm text-[#666] uppercase tracking-wider text-center" data-id="element-41">
              Basado en evidencia científica explicada de forma simple y humana.
            </p>
          </div>
        </div>
      </div>
    </section>;
}